import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import originalEn from 'vee-validate/dist/locale/en'
import originalRu from 'vee-validate/dist/locale/ru'
import en from '@/locales/validation/en'
import ru from '@/locales/validation/ru'
import i18n from './i18n'
import moment from 'moment'

Vue.use(VeeValidate, {
  behavior: 'eager',
  dictionary: {
    ru: { ...originalRu, ...ru },
    en: { ...originalEn, ...en }
  },
  i18n: i18n,
  i18nRootKey: 'validation'
})

Validator.extend('selected', {
  validate: (value, item) => {
    return {
      valid: item[0] !== null
    }
  }
})

Validator.extend('typesRequired', {
  validate: (value, args) => {
    const schema = args.schema
    let valid = false
    for (const [modelIndex, modelItem] of value.entries()) {
      if (!modelIndex && !modelItem) {
        break
      }
      const nextLevel = schema[modelIndex + 1]
      if (nextLevel) {
        const hasChildren = nextLevel.find(item => {
          return item.parents.includes(modelItem)
        })
        if (hasChildren) {
          if (!value[modelIndex + 1]) {
            valid = false
            break
          }
        }
      }
      valid = true
    }
    return {
      valid
    }
  }
})

Validator.extend('validateMinDate', {
  validate: (value, args) => {
    if (value) {
      const currentDate = moment(new Date(value))
      const minDate = moment(new Date(args[0]))
      const diff = currentDate.diff(minDate, 'day')

      return diff >= 0
    }

    return true
  },
  params: ['minDate', 'message'],
  getMessage: (field, args) => {
    return 'Дата не может быть ранее даты ' + args[1]
  }
})

Validator.extend('validateSpecialCharacters', {
  validate: (value) => {
    // ~!@#$%^&{}”;%?` - запрет на символы
    return !!/^[а-яЁёА-Яa-zA-Z0-9_.\-()*:,/[\] ]*$/.test(value)
  },
  getMessage: () => {
    return 'Поле не может содеражать специальные символы.'
  }
})

Validator.extend('correctDate', {
  getMessage: () => {
    return 'Некорректная дата'
  },
  validate: (field) => {
    const currentDate = moment(field)
    const currentYear = currentDate.year()
    const isValidDate = currentDate.isValid()

    return isValidDate && currentYear > 1970
  }
})

Validator.extend('checkGroupCode', {
  getMessage: () => {
    return 'Профессия/специальность в учебной группе должна соответствовать профессии/специальности в заявке на проведение ДЭ'
  },
  validate: (_, [groupProgramCode = '', competenceCode = '', ...args]) => {
    return groupProgramCode === competenceCode
  }
})
